import React, { useCallback } from 'react'
import { ChatLeftDots, HandThumbsUp, Eye } from 'react-bootstrap-icons'
import { format, isValid } from 'date-fns'
import { formatNumber } from '../../../utils/Helper'

export default function Post({ post, reach, asLink = true, showViews = false, imageHeight = 'h-32' }) {
  // Egyszerű szöveg-vágó helper (kb. 3 sornyi szöveghez)
  const truncateText = useCallback((text, maxChars = 180) => {
    if (!text) return ''
    if (text.length <= maxChars) return text
    return `${text.slice(0, maxChars).trimEnd()}…`
  }, [])

  const content = (
    <>
      <div className="dark:bg-rb-dark-mode-background">
        {post.thumbnail && (
          imageHeight === 'h-72' ? (
            <img
              src={post.thumbnail?.url || post.thumbnail}
              alt={post.text?.slice(0, 40) || 'Post thumbnail'}
              className="w-full h-72 rounded-t-lg"
            />
          ) : (
            <div className="mb-2">
              <img
                src={post.thumbnail?.url || post.thumbnail}
                alt={post.text?.slice(0, 40) || 'Post thumbnail'}
                className="w-full object-cover rounded-md"
              />
            </div>
          )
        )}
        <p className="text-xs px-3 py-2 dark:text-rb-dark-mode-text-grey">
          {post.posted_at && isValid(new Date(post.posted_at))
            ? format(new Date(post.posted_at), 'dd.MM.yyyy - HH:mm')
            : '–'}
        </p>
        {post.text && (
          <p className="font-bold text-xs px-3 dark:text-rb-dark-mode-text-grey">{truncateText(post.text, 180)}</p>
        )}
      </div>
      <div className="dark:bg-rb-dark-mode-background dark:border-rb-dark-mode dark:text-rb-dark-mode-text-grey">
        <div className={`flex ${showViews ? 'justify-between' : 'justify-between'} border-t-1 px-3 py-2 dark:text-rb-dark-mode-text-grey`}>
          <div className="flex items-center text-xs"> <span className="opacity-40 mr-2 dark:text-white"><ChatLeftDots /></span> <p className="font-bold dark:text-rb-dark-mode-text-grey">{formatNumber(post.comments_count)}</p></div>
          <div className="flex items-center text-xs"> <span className="opacity-40 mr-2 dark:text-white"><HandThumbsUp /></span> <p className="font-bold dark:text-rb-dark-mode-text-grey">{formatNumber(post.likes_count)}</p></div>
          {showViews && (
            <div className="flex items-center text-xs"> <span className="opacity-40 mr-2 dark:text-rb-dark-mode-text-grey"><Eye /></span> <p className="font-bold">{formatNumber(post.views_count)}</p></div>
          )}
        </div>
        <div className="flex justify-between border-t-1 px-3 py-2">
          <p className="text-xs dark:text-rb-dark-mode-text-grey">CFR <span className="font-bold dark:text-rb-dark-mode-text-grey">{(post.comments_count / reach * 100).toFixed(2)} %</span></p>
          <p className="text-xs dark:text-rb-dark-mode-text-grey">Eng. rate <span className="font-bold dark:text-rb-dark-mode-text-grey">{((post.likes_count + post.comments_count) / reach * 100).toFixed(2)} %</span></p>
        </div>
      </div>
    </>
  )

  if (asLink && post.url) {
    return (
      <a className="rounded-lg w-64 border-1 flex flex-col justify-between overflow-hidden bg-white dark:bg-rb-dark-mode dark:border-rb-dark-mode-lighter" href={post.url} target="_blank">
        {content}
      </a>
    )
  }

  return (
    <div className="rounded-lg w-64 border-1 flex flex-col justify-between overflow-hidden bg-white dark:bg-rb-dark-mode dark:border-rb-dark-mode-lighter">
      {content}
    </div>
  )
}
